<template>
  <div class="export-step">
    <div class="export-header right">
      <i class="el-icon-close" @click="close"></i>
    </div>
    <template v-if="+taskType===0">
      <div class="loading" v-loading="loading" :element-loading-text="`数据导${text}中……`" v-if="loading"></div>
      <div class="loading center" v-else>数据导{{text}}成功</div>
      <div class="tips">
        <p class="center">导出任务已创建</p>
        <p class="center">若等待时间较长可前往任务列表查看导出进度</p>
      </div>
      <div class="buttons right">
        <el-button @click="close">留在本页</el-button>
        <el-button @click="goTo">去任务列表</el-button>
      </div>
      <a :href="fileUrl" class="hidden" ref="downloadExport"></a>
    </template>
    <template v-else>
      <div class="loading" v-loading="loading" element-loading-text="正在导入不存在的保单数据" v-if="loading"></div>
      <div class="loading center" v-else>数据导{{text}}成功</div>
      <div class="tips">
        <p class="center">请不要关闭页面，不存在的保单需先进行导入后再进行结算</p>
        <p class="center">若数据量较大建议分批导入结算</p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'yblExport',
  props: {
    taskId: {
      type: String | Number,
      default: () => ''
    },
    isFeiche: {
      type: Boolean,
      default: () => false
    },
    taskType: {
      type: String | Number,
      default: () => 0 // 任务类型 0：导出 1：导入
    },
    busiType: { // 1  保单导出 2 保单导入 200 非车保单导出 5 上游结算导入保单
      type: String | Number,
      default: () => ''
    }
  },
  data () {
    return {
      loading: true,
      timer: null,
      fileUrl: '',
      text: ['出', '入'][+this.taskType]
    }
  },
  mounted () {
    let _this = this
    this.$nextTick(() => {
      _this.timer = setInterval(() => {
        if (_this.loading) {
          _this.getExportTaskByParams().then(data => {
            _this.loading = (+_this.taskType === 0) ? !(data.curRecord > 0 && data.curRecord === data.totalRecord) : ![20, -1, 16].includes(+data.status)
            if (!_this.loading) {
              if (+_this.taskType === 0) {
                _this.downloadEvent(data)
              } else {
                _this.$emit('next', data) // data.status 20 成功 -1 失败 16 取消
              }
            }
          }).catch(() => {
            _this.loading = false
          })
        }
      }, 3000)

      _this.$once('hook:beforeDestroy', () => {
        clearInterval(_this.timer)
      })
    })
  },
  methods: {
    close () {
      this.$emit('close')
    },
    goTo () {
      clearInterval(this.timer)
      this.$emit('goTo')
    },
    downloadEvent (row) {
      this.fileUrl = row.fileUrl
      let _this = this
      this.$nextTick(() => {
        _this.$refs['downloadExport'].click()
        this.$emit('close')
      })
    },
    getExportTaskByParams () {
      let form = {
        cusOrgId: '', // 保单导入导出当前操作人组织id
        customerId: '', // 操作人
        status: '', // 状态
        startAddTime: '', // 创建开始时间
        endAddTime: '', // 创建结束时间
        clientIP: '', //
        supplierId: '',
        pageNum: '1', // 页码
        pageSize: '10', // 页面大小
        remark: '', //
        title: '', //
        userId: '', //
        userName: '',
        taskId: this.taskId,
        taskType: this.taskType, // 任务类型 0：导出 1：导入
        busiType: this.busiType// +this.taskType + 1//  1  保单导出 2 保单导入 200 非车保单导出 5 上游结算导入保单
      }
      /* if (this.busiType) {
        form.busiType = this.busiType
      } */
      if (this.isFeiche) {
        form.busiType = 200
      }
      return this.$store.dispatch('exportGetExportTaskByParams', form).then(data => {
        console.log(data)
        let _data = data.datas && data.datas.length && data.datas[0]
        _data.message = data.message
        return _data
      })
    }
  }
}
</script>

<style lang="less">
.export-step{
  .loading{
    padding: 60px;
  }
  .tips{
    padding: 30px;
  }
  .el-icon-close{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/exportStep.vue